import { brandConfig } from "../../../config/brand";
import { Section } from "../ui/Section";

const faqs = [
  {
    question: "Τι είναι το TryBrainTest;",
    answer:
      "Το TryBrainTest είναι ένα IQ-style logic challenge που αξιολογεί την επίδοσή σου σε μοτίβα, χωρική αντίληψη, συμβολική λογική, κανόνες και ταχύτητα απάντησης. Στο τέλος μπορείς να ξεκλειδώσεις ένα Premium Report με αναλυτική εικόνα της επίδοσής σου."
  },
  {
    question: "Πόση ώρα διαρκεί;",
    answer:
      "Οι περισσότεροι χρήστες ολοκληρώνουν το test σε περίπου 8-12 λεπτά. Ο χρόνος κάθε απάντησης καταγράφεται και χρησιμοποιείται στο report ως μέρος της ανάλυσης επίδοσης."
  },
  {
    question: "Τι περιλαμβάνει το Premium Report;",
    answer:
      "Το Premium Report περιλαμβάνει IQ Score, εύρος εκτίμησης, ενδεικτική θέση επίδοσης, ανάλυση σε βασικές διαστάσεις, χρονική ανάλυση, δείκτη συνέπειας, ερμηνεία προφίλ και προτάσεις επόμενων βημάτων."
  },
  {
    question: "Χρειάζεται λογαριασμός;",
    answer:
      "Όχι. Μπορείς να ξεκινήσεις χωρίς λογαριασμό. Αν ξεκλειδώσεις report ή ζητήσεις υπενθύμιση προόδου, μπορεί να ζητηθεί email για πρόσβαση, υποστήριξη ή ενημέρωση."
  },
  {
    question: "Είναι επίσημο IQ test;",
    answer:
      "Το TryBrainTest είναι IQ-style logic challenge και παρέχει ενδεικτική αναφορά επίδοσης στο συγκεκριμένο test. Δεν προορίζεται για κλινική, διαγνωστική, εκπαιδευτική ή εργασιακή αξιολόγηση."
  },
  {
    question: "Πώς υπολογίζεται το IQ Score;",
    answer:
      "Το IQ Score βασίζεται στις σωστές απαντήσεις, στη δυσκολία των ερωτήσεων, στον χρόνο απόκρισης και στη συνολική συνέπεια του προφίλ απαντήσεων. Παρουσιάζεται ως ενδεικτικός δείκτης επίδοσης στο TryBrainTest."
  },
  {
    question: "Μπορώ να συγκρίνω την πρόοδό μου αργότερα;",
    answer:
      "Ναι. Μπορείς να ζητήσεις υπενθύμιση προόδου ώστε να ξαναδοκιμάσεις το TryBrainTest μετά από ένα εύλογο χρονικό διάστημα και να συγκρίνεις την επίδοσή σου με νέο report."
  },
  {
    question: "Τι γίνεται αν κλείσω τη σελίδα;",
    answer:
      "Για την καλύτερη εμπειρία, ολοκλήρωσε το test σε μία συνεχή προσπάθεια. Αν κλείσεις τη σελίδα πριν ολοκληρώσεις, ενδέχεται να χρειαστεί να ξεκινήσεις ξανά."
  },
  {
    question: "Πού μπορώ να επικοινωνήσω;",
    answer: `Για υποστήριξη σχετικά με το test, το report ή την πρόσβαση σε αποτέλεσμα, μπορείς να επικοινωνήσεις στο ${brandConfig.supportEmail}.`
  }
];

export function FaqSection() {
  return (
    <Section id="faq" className="scroll-mt-24 py-12 sm:py-16">
      <h2 className="text-3xl font-bold text-white sm:text-4xl">Συχνές ερωτήσεις</h2>
      <div className="mt-7 grid gap-3">
        {faqs.map((faq) => (
          <details key={faq.question} className="group rounded-2xl border border-cyan-200/10 bg-white/[0.05] p-5 shadow-[inset_0_1px_0_rgb(255_255_255_/_0.04)]">
            <summary className="cursor-pointer list-none text-base font-semibold text-white marker:hidden">
              <span className="flex items-center justify-between gap-4">
                {faq.question}
                <span className="text-xl text-cyan-100 transition group-open:rotate-45">+</span>
              </span>
            </summary>
            <p className="mt-3 text-sm leading-6 text-slate-300">{faq.answer}</p>
          </details>
        ))}
      </div>
    </Section>
  );
}
